import { render } from "./designAttachmentPreview.vue?vue&type=template&id=591d1c30&scoped=true"
import script from "./designAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./designAttachmentPreview.vue?vue&type=script&lang=js"

import "./designAttachmentPreview.vue?vue&type=style&index=0&id=591d1c30&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591d1c30"]])

export default __exports__